function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { $uniUP } from "../..";
export var SidebarTooltipController = /*#__PURE__*/function () {
  SidebarTooltipController.$inject = ["$element", "$timeout", "$window", "$log"];
  function SidebarTooltipController($element, $timeout, $window, $log) {
    _classCallCheck(this, SidebarTooltipController);
    this.$timeout = $timeout;
    this.$window = $window;
    this.$log = $log;
    this.$anchor = $element.find("a");
  }
  return _createClass(SidebarTooltipController, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info("Instanciando sidebar tooltip", this.title);
      var title = this.title || this.$anchor.attr("title") || this.$anchor.attr("titleDev");
      if (!title) return;
      this.$window.tippy(this.$anchor[0], {
        content: title,
        allowHTML: true,
        arrow: true,
        trigger: "mouseenter",
        theme: "unimat",
        placement: "right",
        popperOptions: {
          modifiers: {
            preventOverflow: {
              boundariesElement: "window"
            }
          }
        }
      });
    }
  }]);
}();
/**
 * Panel lateral de acceso rápido a los tipos de catálogo
 */
$uniUP.component("sidebarTooltip", {
  bindings: {
    title: "@"
  },
  controller: SidebarTooltipController
  // transclude: true,
  // template : "<ng-transclude></ng-transclude>"
});